__turbopack_context__.v({
  "caret": "PhoneNumberInput-module-scss-module__GSc7kG__caret",
  "country-code": "PhoneNumberInput-module-scss-module__GSc7kG__country-code",
  "flag-selector-btn": "PhoneNumberInput-module-scss-module__GSc7kG__flag-selector-btn",
  "input-container": "PhoneNumberInput-module-scss-module__GSc7kG__input-container",
  "phone-number-input": "PhoneNumberInput-module-scss-module__GSc7kG__phone-number-input",
  "selected-flag": "PhoneNumberInput-module-scss-module__GSc7kG__selected-flag",
});
